import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const avatarThemeToken: any = {
  //======================== COLORS =========================//
  groupBorderColor: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextLightSolid: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorTextPlaceholder: variableColors["ColorFigmaComplementaryBlue30"],

  //======================== FONT =========================//
  fontSize: parseInt(variableTypography["BodyMediumFontSize"]),
  textFontSize: parseInt(variableTypography["BodyMediumFontSize"]),
  textFontSizeLG: parseInt(variableTypography["BodyMediumFontSize"]),
  textFontSizeSM: parseInt(variableTypography["BodyMediumFontSize"]),
  fontFamily: variableTypography["BodyMediumFontFamily"],
  fontWeight: 700,
};
